/* eslint-disable css-modules/no-undef-class, css-modules/no-unused-class */
import { FC, useState } from 'react';
import { Button, LearningPanelNotification } from 'common-components';
import { useTranslationContext } from '../../contexts/translationContext';
import UsernameOrEmail from '../../usernameOrEmailComponent/usernameOrEmail';
import { ArrowBack } from '../../uiLibraryImports';
import styles from './forgetPassword.module.scss';

const ForgetPassword: FC<ForgetPasswordProps> = (props: ForgetPasswordProps) => {
    const { errorMessage, sendVerfiction, isLoading, generalError, onBackToLogin } = props;
    const { translate } = useTranslationContext();

    const [emailAddress, setEmailAddress] = useState<string>('');
    const [invalidEmail, setInvalidEmail] = useState<boolean>(true);

    const isEnabled = !invalidEmail && emailAddress;

    const onEmailChange = ({ value, isValidEmail }) => {
        setEmailAddress(value);
        setInvalidEmail(!isValidEmail);
    };

    return (
        <div className={styles['login-wrapper']}>
            <div className={styles['login-text']}>{translate('ForgotPassword')}</div>
            <div className="inputs">
                <div className={styles.section}>
                    <div className={styles['up-title']}>{translate('EnterEmailAddress')}</div>
                    <UsernameOrEmail
                        usernameOrEmail={emailAddress}
                        onChangeWithValidate={onEmailChange}
                        onlyEmail
                        errorMessage={errorMessage}
                        onError={setInvalidEmail}
                    />
                </div>
                <div className={styles.section}>
                    <div className={styles['forget-password-text']}>{translate('ForgetPasswordEmailPartOne')}</div>
                </div>
                <div className={styles.section}>
                    <div className={styles['forget-password-text']}>{translate('ForgetPasswordEmailPartTwo')}</div>
                </div>
                <div className={styles['general-error-wrapper']}>
                    {generalError && (
                        <LearningPanelNotification
                            notificationText={generalError}
                            hasClose={false}
                            variant="error"
                            handleClose={() => undefined}
                        />
                    )}
                </div>
            </div>
            <div className="buttons">
                <Button
                    type={isEnabled ? 'bigGradient' : 'bigGradientDisable'}
                    onClick={isEnabled ? () => sendVerfiction(emailAddress) : undefined}
                    text={translate('SendVerification')}
                    isLoading={isLoading}
                    lowerCase
                />
            </div>
            <div className="back-to-login" onClick={() => onBackToLogin()}>
                <ArrowBack className="arrow-back" />
                <div data-testid="text">{translate('backToLogin')}</div>
            </div>
        </div>
    );
};

interface ForgetPasswordProps {
    sendVerfiction: Function;
    onBackToLogin: Function;
    errorMessage?: string;
    isLoading?: boolean;
    generalError: string;
}

export default ForgetPassword;
